var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"width":_vm.width,"flat":""}},[_c('div',{staticClass:"rounded-3xl border-red-400 bg-gray h-36 w-full"}),_c('div',{staticClass:"h-5 rounded-3xl border-red-400 bg-gray mt-2 w-4/5"})])}
var staticRenderFns = []

export { render, staticRenderFns }